






























































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { groupCollectionByField, maskHour } from '@/utils/common'
import { TipoMensagemEnum } from '@/types/_'

@Component

export default class ComponentPendenciaBase extends Vue {
  @Prop({ required: true }) display: any
  @Prop({ default: false }) hospital: boolean

  get getPendenciaStore() {
    return getModule(PendenciaStore, this.$store)
  }

  get getMensagens() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  get getTipoMensagemEnum() {
    return TipoMensagemEnum
  }

  groupByDate(value: any) {
    return groupCollectionByField(value)
  }

  formatHour(value: string) {
    return maskHour(value)
  }
}
